// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"daa41611","257":"a142aecc","283":"a20ca669","686":"1acd4ef8","760":"4b38b0ee"}[chunkId] + ".chunk.js";
};